import React, {Component} from 'react';
import AccountInput from '../inputs/AccountInput';
import server from '../server'
import AgencyInput from '../inputs/AgencyInput';

const styles = {
    div:{
        marginBottom:10
    },

    input: {
        margin: "10px 5px",
        width: 150,
    },

    bankField:{
        margin: "0 5px",
        width:73
    },

    button: {
        display: "block",
        margin: "auto",
        marginBottom: 20,
    },

    bank: {
        width:"40%"
    },

    account: {
        width:"40%"
    },

    agency:{
        width:"20%"
    }
}

class ChangePassword extends Component{
    state = {
        password:"",
        password_error:false,
        bank:0
    }

    validate = () => {
        let newState = this.state

        let failed = false

        Object.keys(this.state).forEach(key => {
            if(typeof(newState[key]) == "boolean"){
                newState[key] = false
            }
        })

        this.setState({newState})

        if(this.state.agency == null || this.state.agency.indexOf("_") != -1){
            this.setState({agency_error:true});
            failed = true;
        }

        if(this.state.account == null || this.state.account.indexOf("_") != -1){
            this.setState({account_error:true});
            failed = true;
        }

        if(this.state.bank == null || this.state.account == null || this.state.bank == 0){
            this.setState({bank_error:true})
            failed = true
        }

        if(this.state.password == null || this.state.password.length < 6){
            this.setState({password_error:true})
            failed = true
        }

        if(this.state.password != this.state.confirm_password){
            this.setState({password_error:true,confirm_password_error:true})
            failed = true
        }

        let user = server.user;

        user["password"] = this.state.password
        user["bankId"] = parseInt(this.state.bank)
        user["bankAccount"] = this.state.account
        user["bankAgency"] = this.state.agency

        if(!failed){
            fetch(server.address + "/users/" + user.id,{
              method:"PUT",
              headers:{
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              body:JSON.stringify(user)
            }).then(response => response.json().then(data => {
              this.props.next()
            }))
        }
    }

    render(){
        return(
            <div>
                <div className="row">
                    <div style={styles.div} className="col-xs-12 col-md-6">
                        <label>Senha</label>
                        <input onChange={(event) => this.setState({"password": event.target.value})} class="form-control" id="password" error={this.state.password_error} placeholder="Senha" type="password" required/>
                    </div>
                    <div style={styles.div} className="col-xs-12 col-md-6">
                        <label>Confirme sua senha</label>
                        <input onChange={(event) => this.setState({"confirm_password":event.target.value})} class="form-control" id="confirmPassword" error={this.state.confirm_password_error} placeholder="Confirmar Senha" type="password" required/>
                    </div>
                    <br/><br/><br/><br/>
                    <div className="row">
                        <div style={styles.div} className="col-xs-12 col-md-5">
                            <label>Banco</label>
                            <select class="form-control" style={this.state.bank_error ? {"borderColor":"red"} : {}} value={this.state.bank} onChange={(event) => this.setState({"bank":event.target.value})}>
                                <option value={0}>Selecione um Banco</option>
                                <option value={1}>Banco do Brasil</option>
                                <option value={2}>Caixa</option>
                                <option value={3}>Itaú</option>
                                <option value={4}>Santander</option>
                            </select>
                        </div>
                        <div style={styles.div} className="col-xs-12 col-md-4">
                            <label>Agência</label>
                            <AgencyInput class="form-control" style={this.state.agency_error ? {"borderColor":"red"} : {}} value={this.state.agency} onChange={(event) => this.setState({"agency":event.target.value})} id="agency" error={this.state.agency_error} placeholder="Agência"/>
                        </div>
                        <div style={styles.div} className="col-xs-12 col-md-3">
                            <label>Conta</label>
                            <AccountInput class="form-control" style={this.state.account_error ? {"borderColor":"red"} : {}} value={this.state.account} onChange={(event) => this.setState({"account":event.target.value})} id="account" error={this.state.account_error} placeholder="Conta"/>
                        </div>
                    </div>
                    <br/><br/>
                    <button onClick={this.validate} className="btn btn-default" style={styles.button}>Atualizar Informações</button>
                </div>
            </div>
        )
    }
}

export default ChangePassword;



// WEBPACK FOOTER //
// ./src/forms/ChangePassword.js